export default class ScreeningResultsClient {
    constructor(apiClient) {
        this.baseURI = '/v3/screening_results';
        this.apiClient = apiClient;
        this.postScreeningResult = this.postScreeningResult.bind(this);
        this.getScreeningResults = this.getScreeningResults.bind(this);
        this.getScreeningResult = this.getScreeningResult.bind(this);
        this.deleteScreeningResult = this.deleteScreeningResult.bind(this);
        this.getScreeningResultVersions = this.getScreeningResultVersions.bind(this);
        this.getScreeningResultVersion = this.getScreeningResultVersion.bind(this);
        this.deleteScreeningResultVersion = this.deleteScreeningResultVersion.bind(this);
    }
    postScreeningResult(data, config) {
        return this.apiClient.post(this.baseURI, data, config);
    }
    getScreeningResults(config) {
        return this.apiClient.get(this.baseURI, config);
    }
    getScreeningResult(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}`, config);
    }
    deleteScreeningResult(id, config) {
        return this.apiClient.delete(`${this.baseURI}/${id}`, config);
    }
    getScreeningResultVersions(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/versions`, config);
    }
    getScreeningResultVersion(id, updateId, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/versions/${updateId}`, config);
    }
    deleteScreeningResultVersion(id, updateId, config) {
        return this.apiClient.delete(`${this.baseURI}/${id}/versions/${updateId}`, config);
    }
}
